export const base64ToBlob = (base64: string, type = 'application/pdf') => {
  const bytes = atob(base64);
  const buffer = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) buffer[i] = bytes.charCodeAt(i);
  return new Blob([buffer], { type });
};

export const saveBase64Pdf = (base64: string, fileName: string) => {
  const url = URL.createObjectURL(base64ToBlob(base64));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
